import React from "react";
import NavigationDrawer from "./../../../components/NavigationDrawer/index";
import { Grid } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { setActiveTab } from "../../../lib/slices/activeTabSlice";
import DynamicTabsDrawer from "../../../components/DynamicTabDrawer";
import AllAdmissions from "./AllAdmissions";
import AddEditAdmissionStep1 from "./AddEditAdmissionStep1";
import AddEditAdmissionStep2 from "./AddEditAdmissionStep2";
import AdmissionRequest from "./AdmissionRequest";
import AdmissionReqDetails from "./AdmissionReqDetails";

const tabs = [
  { label: "All Admissions", value: "ed_all_admissions" },
  { label: "Add New Admissions", value: "ed_add_admissions_step1" },
  { label: "Admissions Requests", value: "ed_admission_request" },
];

const EducationAdmission = () => {
  const dispatch = useDispatch();
  // Redux states
  const activeTab = useSelector((state) => state.activeTab.tabs);

  // Function

  const handleChangeTab = (tab) => {
    dispatch(setActiveTab({ ...activeTab, education_admission: tab }));
  };

  return (
    <NavigationDrawer>
      <Grid container spacing={2}>
        <Grid item xs={12} md={2.3}>
          <DynamicTabsDrawer
            primaryHeading={"Admission Section*"}
            tabs={tabs}
            activeTab={activeTab.education_admission}
            handleChangeTab={handleChangeTab}
          />
        </Grid>
        <Grid item xs={12} md={9.7}>
          {activeTab.education_admission === "ed_all_admissions" ? (
            <AllAdmissions />
          ) : activeTab.education_admission === "ed_add_admissions_step1" ? (
            <AddEditAdmissionStep1 />
          ) : activeTab.education_admission === "ed_add_admissions_step2" ? (
            <AddEditAdmissionStep2 />
          ) : activeTab.education_admission === "ed_admission_request" ? (
            <AdmissionRequest />
          ) : activeTab.education_admission ===
            "ed_admission_request_details" ? (
            <AdmissionReqDetails />
          ) : null}
        </Grid>
      </Grid>
    </NavigationDrawer>
  );
};

export default EducationAdmission;
